
import { supabase } from "@/integrations/supabase/client";
import { handleServiceError, withErrorHandling } from "../utils/errorHandling";
import { authService } from "../auth";

/**
 * Service for meal plan statistics and counts
 */
export const mealPlanStatsService = {
  /**
   * Get total count of all meal plans for the current user
   * More efficient than fetching all meal plan data
   */
  getTotalMealPlansCount: withErrorHandling(
    async (): Promise<number> => {
      console.log('Fetching total meal plans count');

      // Get the current user using the centralized auth service
      const currentUser = await authService.getCurrentUser();
      if (!currentUser) {
        console.log("No authenticated user found");
        return 0;
      }
      
      // Count all meal plans for the user (RLS will handle filtering)
      const { count, error } = await supabase
        .from("meal_plans")
        .select("*", { count: 'exact', head: true });

      if (error) {
        console.error("Error counting meal plans:", error);
        throw new Error(`Error counting meal plans: ${error.message}`);
      }

      const totalCount = count || 0;
      console.log(`Total meal plans count: ${totalCount}`);
      return totalCount;
    },
    "Error counting meal plans"
  ),
};
